import { z } from 'zod';
import { applicationDateOrder, idArray, paymentReportsFilterSchema, transactionDateOrder } from './shared.schema';

export const monthlyParkingPaymentReportFormatSchema = z.enum(['csv', 'pdf', 'xlsx']);

const commonFields = z.strictObject({
	accountFilter: paymentReportsFilterSchema.optional(),
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
	format: monthlyParkingPaymentReportFormatSchema.default('csv'),
	facilityNumber: z.union([z.string(), z.number()]).optional(),
});

export const monthlyParkingPaymentParametersSchema = z
	.intersection(commonFields, z.discriminatedUnion('dateOrder', [transactionDateOrder, applicationDateOrder]))
	.superRefine((value, ctx) => {
		if (
			value.transactionStartDate &&
			value.transactionEndDate &&
			value.transactionStartDate > value.transactionEndDate
		) {
			ctx.addIssue({
				code: 'custom',
				path: ['transactionEndDate'],
				message: 'Transaction end date cannot be before transaction start date',
			});
		}

		if (
			value.applicationStartDate &&
			value.applicationEndDate &&
			value.applicationStartDate > value.applicationEndDate
		) {
			ctx.addIssue({
				code: 'custom',
				path: ['applicationEndDate'],
				message: 'Application end date cannot be before application start date',
			});
		}
	});

export type MonthlyParkingPaymentParameters = z.infer<typeof monthlyParkingPaymentParametersSchema>;
export type MonthlyParkingPaymentReportFormat = z.infer<typeof monthlyParkingPaymentReportFormatSchema>;
